import { FC, useRef } from "react";
import { useAppDispatch } from "src/hooks";
import "src/styles/profile.css";
import React, { useState, useEffect } from "react";
import { sat } from '../../types/request.type';


export type TypeSnack = {
	children: string;
	title: string;
} | null;



export const MapPage: FC = () => {


	const dispatch = useAppDispatch();

	const mystyles = {
		position: 'absolute',
		left: '250px',
		top: '40px'
	} as React.CSSProperties;


	const canvasRef = useRef<HTMLCanvasElement>(null);


	const MINUTE_MS = 1000;


	useEffect(() => {

		const interval = setInterval(() => {
			console.log('Logs every minute');


			var sats: sat;

			sats = {
				coord: '',
				resolve: '',
				visible: '',
			}

			var path_file_naviCoord = 'naviCoord';
			var path_file_naviSatsResolve = 'naviSatsResolve';
			var path_file_naviSatsVisible = 'naviSatsVisible';

			const canvas = canvasRef.current;
			if (canvas == null) return;
			const g = canvas.getContext("2d");

			fetch(path_file_naviCoord, {
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				}

			})

				.then((r) => r.text())
				.then((data) => {
					console.log(data)
					sats.coord = data.toString().trim();

					fetch(path_file_naviSatsResolve, {
						headers: {
							'Content-Type': 'application/json',
							'Accept': 'application/json'
						}

					})
						.then((r) => r.text())
						.then((data) => {
							sats.resolve = data.toString().trim();

							fetch(path_file_naviSatsVisible, {
								headers: {
									'Content-Type': 'application/json',
									'Accept': 'application/json'
								}

							})
								.then((r) => r.text())
								.then((data) => {
									sats.visible = data.toString().trim();

									console.log(sats);




									if (g === null) return;

									console.log("xxxxx")
									g.clearRect(0, 0, canvas.width, canvas.height);
									g.beginPath();

									//Our first draw

									g.fillStyle = "white";
									g.fillRect(0, 0, g.canvas.width, g.canvas.height);

									var lastColor = g.fillStyle;
									g.fillStyle = 'white';
									g.fillRect(0, 0, window.innerWidth, window.innerWidth);
									g.fillStyle = lastColor;


									g.beginPath(); // Start a new path
									//context.moveTo(30, 50); // Move the pen to (30, 50)
									//context.lineTo(150, 100); // Draw a line to (150, 100)
									//context.stroke(); // Render the path


									type sat2 = {
										isActive: boolean;
										number: number;
										lat: number;
										lon: number;
										level: number;
									};


									var coordB = '56.6';
									var coordL = '37';
									var date = (new Date()).toString();

									if (sats!.coord.length > 0) {//if}
										if (sats!.coord.split(";").length > 0) coordB = sats!.coord.split(";")[0];
										if (sats!.coord.split(";").length > 1) coordL = sats!.coord.split(";")[1];
										if (sats!.coord.split(";").length > 3) date = sats!.coord.split(";")[3];
									}//if


									//var coords = coordB+';'+coordL+';'+date; 

									var satCountGPS = 0;
									var satCountGLNS = 0;
									var satCountGALILEO = 0;

									var satellites: sat2[] = [];

									var satsResolved = [];


									satsResolved = sats!.resolve.split(",");

									var splits = sats!.visible.split(";");
									for (var i = 0; i < splits.length; i++) {//for

										var sat = splits[i];
										if (sat.split(",").length === 0) continue;

										var satActive = false;

										for (var ii = 0; ii < satsResolved.length; ii++) {//for

											if (parseInt(satsResolved[ii]) === parseInt(sat.split(",")[0])) {
												satActive = true;
												break;

											}

										}

										var satelliteType = "true";
										var satelliteNumber = sat.split(",")[0];

										console.log("satelliteType ===== " + satelliteType)

										if (satelliteType === "false") continue;
										if (parseInt(satelliteNumber) <= 32 && (satelliteType === undefined || satelliteType === "glonass")) continue;
										if (parseInt(satelliteNumber) > 32 && parseInt(satelliteNumber) < 97 && (satelliteType == undefined || satelliteType === "gps")) continue;
										//if(satelliteNumber >= 97 && satelliteNumber <= 126  && (galileo == undefined || galileo == false)) continue; 


										var sat20: sat2;

										sat20 = {
											isActive: satActive,
											number: Number(sat.split(",")[0]),
											lat: (sat.split(",").length > 1) ? Number(sat.split(",")[1]) : 0,
											lon: (sat.split(",").length > 2) ? Number(sat.split(",")[2]) : 0,
											level: (sat.split(",").length > 3) ? Number(sat.split(",")[3]) : 0,
										}

										satellites.push(sat20);

									}//for




									for (var i = 0; i < satellites!.length; i++) {//for
										if (satellites![i].isActive == false) continue;
										if (satellites![i].number <= 32) satCountGPS++; else
											if (satellites![i].number > 32 && satellites![i].number < 97) satCountGLNS++; else
												if (satellites![i].number >= 97 && satellites![i].number <= 126) satCountGALILEO++;
									}//for            


									var componentWidth = 500;
									var componentHeight = 850;



									//Для того, чтобы линии были четкими
									//g.translate(0.5, 0.5); ///!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

									//Рамка
									g.fillStyle = "#f0f0f0";
									g.beginPath();
									g.fillRect(0, 0, componentWidth - 1, componentHeight - 1);
									g.stroke();

									g.strokeStyle = "#101010";
									g.beginPath();
									g.rect(0, 0, componentWidth - 1, componentHeight - 1);
									g.stroke();


									var leftOffset = 20;
									var rightOffset = 20;
									var topOffset = 30;
									var bottomOffset = 10;

									var signalQualityColumnHeight = 60;
									var signalParamsHeight = 45;

									var width = componentWidth;
									var height = componentHeight - signalQualityColumnHeight - signalParamsHeight - topOffset - bottomOffset;

									var radius = Math.ceil((((width > height) ? height : width) - leftOffset - rightOffset) / 2);

									var posX = leftOffset + radius;
									var posY = topOffset + radius;

									////////////////////////////////////////////////////////////////////////////////////////////////////////////
									// Rounds //////////////////////////////////////////////////////////////////////////////////////////////////
									////////////////////////////////////////////////////////////////////////////////////////////////////////////

									g.strokeStyle = "#101010";
									g.fillStyle = "#101010";
									g.font = "12pt Verdana";

									var radiusOffset = Math.ceil(radius / 4);
									for (var i = 0; i < 4; i++) {//for
										g.beginPath();
										g.arc(posX, posY, radius - radiusOffset * i, 0, 2 * Math.PI, false);
										g.stroke();
									}//for


									////////////////////////////////////////////////////////////////////////////////////////////////////////////
									// Axes ////////////////////////////////////////////////////////////////////////////////////////////////////
									////////////////////////////////////////////////////////////////////////////////////////////////////////////

									var innOffset = 0;

									var x1 = posX - radius - innOffset;
									var x2 = posX + radius + innOffset;

									var y1;
									var y2 = posY;

									g.beginPath();
									g.moveTo(x1, y2);
									g.lineTo(x2, y2);
									g.stroke();

									g.fillText("W", x1 - g.measureText("W").width - 2, y2 + 5);
									g.fillText("E", x2 + 2, y2 + 5);


									x1 = posX;
									x2 = posX;

									y1 = posY + radius + innOffset;
									y2 = posY - radius - innOffset;

									g.beginPath();
									g.moveTo(x1, y1);
									g.lineTo(x2, y2);
									g.stroke();

									g.fillText("S", x1 - 6, y1 + 15);
									g.fillText("N", x2 - 6, y2 - 5);


									////////////////////////////////////////////////////////////////////////////////////////////////////////////
									// Params //////////////////////////////////////////////////////////////////////////////////////////////////
									////////////////////////////////////////////////////////////////////////////////////////////////////////////

									innOffset = 25;

									g.fillStyle = "#101010";
									g.font = "8pt Verdana";


									if (coordB == undefined || coordL == undefined || date == undefined) {

										//g.font = "10pt Verdana";
										g.fillText(("glns count") + ": " + 0, posX + radius - g.measureText(("glns count")).width - 20 - 10, posY + radius + innOffset - 15);
										g.fillText(("gps count") + ": " + 0, posX + radius - g.measureText(("gns count")).width - 46 + 15, posY + radius + innOffset + 5);
										g.fillText(("galileo count") + ": " + 0, posX + radius - g.measureText(("galileo count")).width - 20 - 10, posY + radius + innOffset + 25);

										return;
									}

									//const options = {year: 'numeric', month: 'numeric', day: 'numeric' };

									if (coordB.trim().length > 0) g.fillText(("b") + ": " + coordB, 10, 15);
									if (coordL.trim().length > 0) g.fillText(("l") + ": " + coordL, 10, 30);
									if (date.trim().length > 0) g.fillText((new Date(date)).toLocaleString('ru-RU') + " (GMT)", 334, 15);


									//g.font = "10pt Verdana";
									g.fillText(("glns count") + ": " + satCountGLNS, posX + radius - g.measureText(("glns count")).width - 20 - 10, posY + radius + innOffset - 15);
									g.fillText(("gps count") + ": " + satCountGPS, posX + radius - g.measureText(("gns count")).width - 46 + 15, posY + radius + innOffset + 5);
									g.fillText(("galileo count") + ": " + satCountGALILEO, posX + radius - g.measureText(("galileo count")).width - 20 - 10, posY + radius + innOffset + 25);

									/*		g.strokeStyle = "#201010";
											g.fillStyle = "rgba(155, 10, 10, 0.6)";*/

									var sx1 = posX + g.measureText(("glns count")).width + 70;
									var sy1 = posY + radius + innOffset - 18;

									var sx2 = posX + g.measureText(("gns count")).width + 126;
									var sy2 = posY + radius + innOffset + 2;

									var sx3 = posX + g.measureText(("galileo count")).width + 75;
									var sy3 = posY + radius + innOffset + 25;

									g.fillText(("Satellite for solve"), 46, sy2 + 3);

									g.fillText(("Visible satellite"), 46, sy2 + 3 + 24 - 5);

									g.beginPath();
									g.rect(sx2 - 7 - 60, sy2 - 7, 14, 14); ///gps
									g.stroke();
									//g.fill();  

									g.beginPath();
									g.arc(sx1 - 7, sy1, 7, 0, 2 * Math.PI, false); ///glonas   
									g.stroke();
									//g.fill();  

									g.beginPath();
									g.moveTo(sx3 + 0 - 25, sy3 - 10);
									g.lineTo(sx3 + 7 - 25, sy3 + 4);
									g.lineTo(sx3 - 7 - 25, sy3 + 4);
									g.closePath();
									g.stroke();
									//g.fill();  


									g.strokeStyle = "#102010";
									g.fillStyle = "rgba(10, 155, 10, 0.6)";
									g.beginPath();
									g.rect(10, sy2 - 7, 30, 14);
									g.stroke();
									g.fill();

									g.strokeStyle = "#201010";
									g.fillStyle = "rgba(155, 10, 10, 0.6)";
									g.beginPath();
									g.rect(10, sy2 + 17 - 5, 30, 14);
									g.stroke();
									g.fill();



									////////////////////////////////////////////////////////////////////////////////////////////////////////////
									// Sats ////////////////////////////////////////////////////////////////////////////////////////////////////
									////////////////////////////////////////////////////////////////////////////////////////////////////////////

									var maxLat = 90;
									var offsLon = 90;

									var levelX = leftOffset;
									var levelY = posY + radius + signalParamsHeight + innOffset;

									var levelWidth = Math.ceil(2 * radius / 12);
									var levelHeight = signalQualityColumnHeight;


									for (var i = 0; i < satellites!.length; i++) {//for

										var sat22 = satellites![i];

										//paramsSat.number <= 32) satCountGPS++;

										var satNumber = sat22.number;
										var lat = (sat22.lat >= 0 && sat22.lat <= 90) ? sat22.lat : 0; //0 - 90 (широта)
										var lon = (sat22.lon >= 0 && sat22.lon <= 360) ? sat22.lon : 0; //0 - 360 (долгота)


										var rad = ((lat > 0) ? radius * (maxLat - lat) / maxLat : radius);
										var sx = posX + rad * Math.cos((lon - offsLon) * Math.PI / 180);
										var sy = posY + rad * Math.sin((lon - offsLon) * Math.PI / 180);

										if (sat22.isActive == true) {//if
											g.strokeStyle = "#102010";
											g.fillStyle = "rgba(10, 155, 10, 0.6)";
										} else {//else
											g.strokeStyle = "#201010";
											g.fillStyle = "rgba(155, 10, 10, 0.6)";
										}//else

										g.beginPath();

										if (sat22.number <= 32) g.rect(sx - 10, sy - 10, 20, 20); ///gps
										if (sat22.number > 32 && sat22.number < 97) g.arc(sx, sy, 10, 0, 2 * Math.PI, false); ///glonas                
										if (sat22.number >= 97 && sat22.number <= 126) {///galileo                
											g.beginPath();
											g.moveTo(sx + 15 - 15, sy + 1 - 22);
											g.lineTo(sx + 30 - 15, sy + 30 - 22);
											g.lineTo(sx + 3 - 17, sy + 30 - 22);
											g.closePath();
										}


										g.stroke();
										g.fill();

										g.fillStyle = "rgb(10, 10, 10)";
										g.font = "7pt Verdana";

										g.fillText(String(satNumber), sx - g.measureText(String(satNumber)).width / 2, sy + 4);

										// Уровни сигнала
										var level = (sat22.isActive == true) ? ((sat22.level >= 0 && sat22.level <= 100) ? sat22.level : 0) : 0;
										var maxLevel = 100;

										if (sat22.isActive == true) {//if
											var tmp = levelHeight * level / maxLevel;
											g.beginPath();
											g.fillStyle = "#105010";
											g.fillRect(levelX, levelY + levelHeight - tmp, levelWidth - 10, levelHeight * level / maxLevel);
											g.stroke();
										}//if

										g.beginPath();
										g.fillStyle = "#101010";
										g.rect(levelX, levelY, levelWidth - 10, levelHeight);
										g.stroke();

										g.font = "8pt Verdana";
										g.fillText(String(satNumber), levelX + (levelWidth - 10 - g.measureText(String(satNumber)).width) / 2, levelY + levelHeight + 10);

										g.fillStyle = "#707070";
										g.fillText(String(level), levelX + (levelWidth - 10 - g.measureText(String(level)).width) / 2, levelY - 4);

										levelX += levelWidth;
										if (i == 11 || i == 23) { levelX = leftOffset; levelY += levelHeight + 30; }

									}//for




								});


						});



				});

			//let img = new Image();
			//
			//img.src = "https://i.imgur.com/vzGhITt.jpeg";
			//
			//img.onload = () => {
			//  context.drawImage(img, 0, 0, 300, 200);
			//};

		}, MINUTE_MS);


		return () => {

			//const canvas = canvasRef.current;
			//if (canvas == null) return;
			//const g = canvas.getContext("2d");

			//g!.clearRect(0, 0, canvas.width, canvas.height);
			//g!.beginPath();
			clearInterval(interval);
		}

	}, []);

	return <div id='d3' style={mystyles}>
		<canvas id={"canvas2D"} width={1300} height={1300} ref={canvasRef} />;
	</div>
}
